import { Chain } from 'viem'
import axios, { AxiosResponse } from 'axios'

import { Hash, OwnedToken } from 'types/entities'

import { convert } from 'utils/helpers'
import { CHAIN_INFO } from 'constants/chains'
import { COVALENT_PREFIX, COVALENT_KEY } from 'constants/api'

type CovalentToken = {
  type: string
  balance: string
  is_spam: boolean
  logo_url: string
  balance_24h: string
  native_token: boolean
  supports_erc: string[]
  contract_address: string
  last_transferred_at: string
  contract_name: null | string
  contract_ticker_symbol: string
  contract_decimals: null | number
}

type Response = {
  items: CovalentToken[]
}

export async function covalent(_address: Hash, chain: Chain) {
  const { data }: AxiosResponse<{ data: Response }> = await axios.get(
    COVALENT_PREFIX + `${CHAIN_INFO[chain.id].id}/address/${_address}/balances_v2/?key=${COVALENT_KEY}`,
  )

  const result = data?.data.items.reduce<OwnedToken[]>((acc, curr) => {
    if (!curr.contract_ticker_symbol) {
      return acc
    }
    const result = convert({
      balance: curr.balance,
      name: curr.contract_name,
      address: curr.contract_address,
      decimals: curr.contract_decimals,
      symbol: curr.contract_ticker_symbol,
    })
    return acc.concat(result)
  }, [])

  return result as OwnedToken[]
}
